import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { signoutRedirect } from 'services/actions/Autenticacao/AuthService';
import { setRepresented, setRepresents } from 'store/actions/userActions';
import { setUserValid } from 'store/actions/stepperActions';
import { setAtualizarDadosCadastrais } from 'store/actions/dadoCadastralActions';
import { clearDialogs } from 'store/actions/dialogActions';
import { ObterPessoaJuridica, ObterPessoaFisica } from 'services/actions/DadoCadastral';
import { ObterDadosCPF, ObterDadosCNPJ } from 'services/actions/ConectaGovRepem';

const styles = `
    .div-content-user-info { display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-flex-direction: column; -ms-flex-direction: column; flex-direction: column; margin-right: 30px; }
    .div-content-user { display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; font-size: 14px; -webkit-align-items: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; margin-left: auto; }
    .div-content-anm-header { display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-align-items: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; background: #304c66; padding: 10px 15px; min-height: 100px; font-family: Roboto, Verdana, sans-serif, arial, helvetica; }
    .div-content-anm-header { display: -webkit-box; display: -webkit-flex; display: -ms-flexbox; display: flex; -webkit-align-items: center; -webkit-box-align: center; -ms-flex-align: center; align-items: center; background: #304c66; padding: 10px 15px; min-height: 100px; } 
    @media (max-width: 900px) { .div-content-user { margin: 0; } .div-content-anm-header { -webkit-flex-direction: column; -ms-flex-direction: column; flex-direction: column; -webkit-align-items: flex-start; -webkit-box-align: flex-start; -ms-flex-align: flex-start; align-items: flex-start; } }
    .div-anm-modal-alterar-representacao { position: fixed; z-index: 1; left: 0; top: 0; width: 100%; height: 100%; overflow: auto; background-color: rgb(0,0,0); background-color: rgba(0,0,0,0.4); }
    .div-anm-modal-alterar-representacao-content { background-color: #fefefe; margin: 50px auto; padding: 20px; border-radius: 10px; width: 400px; display: flex; flex-direction: column; justify-content: center; }
    .div-anm-modal-alterar-representacao-buttons { display: flex; flex-direction: row; justify-content: center; }
    .div-anm-modal-alterar-representacao-button { background: #3282aa; padding: 3px; margin-left: 5px; margin-right: 5px; color: #fff; border-radius: 10px; cursor: pointer; width: 70px; height: 35px; }
 `;


function Header() {
  const [selectedRepresentado, setSelectedRepresentado] = useState(-1);
  const [isUserContentVisible, setUserContentVisible] = useState(false);
  const [isSelectRepresentadosVisible, setSelectRepresentadosVisible] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const dispatch = useDispatch();
  const { user, represents, represented } = useSelector((store) => {
    return store.userState;
  });

  useEffect(() => {
    setUserContentVisible(!!user && user.token && user.token.length > 0);
    setSelectRepresentadosVisible(!!represents && represents.length > 0 && user?.userType && user.userType === '2');
  }, [user, represents]);

  // sincroniza select
  useEffect(() => {
    setSelectedRepresentado(
      represented?.representedId ?? -1
    );
  }, [represented?.representedId]);

  // limpa estado dependente
  useEffect(() => {
    dispatch(setAtualizarDadosCadastrais({
      necessarioAtualizar: false,
      url: ''
    }));
    dispatch(clearDialogs());
  }, [represented?.representedId]);

  const confirmChangeRepresentado = async () => {
    let selectedRepresented = {
      descricao: '',
      nome: '',
      id: -1,
    };

    if (
      selectedRepresentado &&
      selectedRepresentado > 0 &&
      selectedRepresentado !== user.userCpf
    ) {
      selectedRepresented = represents.find(
        (r) => r.id === selectedRepresentado
      );
    }

    //Logica do SRS
    if (selectedRepresented?.nome?.toUpperCase()?.includes('SRS')) {
      if (selectedRepresentado.length === 11) {
        let pessoaFisica = await ObterPessoaFisica(selectedRepresented?.id || null);

        if (!pessoaFisica) {
          pessoaFisica = await ObterDadosCPF(selectedRepresented?.id || null);
        }

        if (pessoaFisica) {
          selectedRepresented.nome = pessoaFisica.nomeRazaoSocial;

          const index = represents.findIndex(
            (r) => r.id === selectedRepresentado
          );

          if (index !== -1) {
            represents[index] = {
              ...represents[index],
              ...selectedRepresented,
            };

            dispatch(setRepresents([...represents]));
          }
        }
      } else {
        let pessoaJuridica = await ObterPessoaJuridica(selectedRepresented?.id || null);

        if (!pessoaJuridica) {
          pessoaJuridica = await ObterDadosCNPJ(selectedRepresented?.id || null);
        }

        if (pessoaJuridica) {
          selectedRepresented.nome = pessoaJuridica.nomeRazaoSocial;

          const index = represents.findIndex(
            (r) => r.id === selectedRepresentado
          );

          if (index !== -1) {
            represents[index] = {
              ...represents[index],
              ...selectedRepresented,
            };

            dispatch(setRepresents([...represents]));
          }
        }
      }
    }

    // Atualiza o redux
    dispatch(setRepresented(selectedRepresented));

    dispatch(setUserValid(false));

    setModalVisible(false);
  };

  const handleLogout = () => {
    signoutRedirect(dispatch);
  };

  return (
    <>
      <style type="text/css" scoped>{styles}</style>
      <div className="div-content-anm-header">
        <div>
          <img
            id="anm-logo-header"
            src={`${window.location.origin}/images/logo.svg`}
            alt="ANM - Agência Nacional de Mineração"
          />
        </div>
        {isUserContentVisible && (
          <div id="div-anm-content-user" className="div-content-user">
            <div className="div-content-user-info">
              <span style={{ fontWeight: "bold", color: "#fff" }}>
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 448 512"
                  height="12px"
                  width="12px"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ marginRight: "3px" }}
                >
                  <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"></path>
                </svg>
                <span id="anm-descricao-usuario">Bem vindo(a) {user.userName}</span>
              </span>
              <span id="anm-descricao-representado" style={{ color: "#fff" }}>{represented.representedName}</span>
              {/* O contêiner do select agora é controlado pelo estilo CSS */}
              {isSelectRepresentadosVisible && <div>
                <select
                  id="anm-select-representados"
                  value={selectedRepresentado || -1}
                  onChange={(e) => setSelectedRepresentado(e.target.value)}
                  style={{
                    width: "200px",
                    height: "35px",
                    border: "1px solid #ddd",
                    color: "#000",
                    backgroundColor: "#fff",
                    marginTop: "5px",
                    borderRadius: "5px",
                  }}
                >
                  <option value="">Selecione uma representação</option>
                  {represents.map(represent => (
                    <option key={represent.id} value={represent.id}>
                      {represent.nome} - {represent.id}
                    </option>
                  ))}
                </select>
                <button
                  id="anm-button-alterar-representado"
                  onClick={() => setModalVisible(true)}
                  style={{
                    background: "#3282aa",
                    height: "35px",
                    padding: "3px",
                    marginLeft: "5px",
                    color: "#fff",
                    borderRadius: "10px",
                    cursor: "pointer",
                  }}
                >
                  Alterar Representação
                </button>
              </div>}
            </div>
            <svg
              id="anm-button-logout"
              focusable="false"
              viewBox="0 0 24 24"
              aria-hidden="true"
              style={{
                fill: "currentColor",
                width: "25px",
                height: "25px",
                display: "inline-block",
                transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                flexShrink: 0,
                userSelect: "none",
                color: "#fff",
                cursor: "pointer",
              }}
              onClick={handleLogout}
            >
              <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"></path>
            </svg>
          </div>
        )}
        {isModalVisible && (
          <div id="anm-modal-alterar-representacao" className="div-anm-modal-alterar-representacao">
            <div className="div-anm-modal-alterar-representacao-content">
              <div style={{ paddingBottom: "20px", textAlign: "center" }}>Deseja realmente alterar a representação?</div>
              <div className="div-anm-modal-alterar-representacao-buttons">
                <button className="div-anm-modal-alterar-representacao-button" onClick={confirmChangeRepresentado}> Sim </button>
                <button className="div-anm-modal-alterar-representacao-button" onClick={() => setModalVisible(false)}> Não </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Header;
